import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function TooltipPopoverTrigger({
  termineCount,
}: {
  termineCount: number;
}) {
  return (
    <div className="flex gap-1 items-center justify-center px-2 py-1.5 rounded-md bg-neutrals-N200 text-neutrals-N900 h-10">
      <FontAwesomeIcon icon={faCalendarStar} />
      <div className="text-sm">{termineCount}</div>
    </div>
  );
}
